import React from "react";
import { useFlexfuelOffer, resolveOffer } from "../../hooks/useFlexfuelOffer";

export const SEOEditorialSection = ({ reviews = { rating: 4.8, user_ratings_total: 88 }, content }) => {
  const offer = useFlexfuelOffer();
  const seo = content?.seo_editorial || {
    eyebrow: "Notre expertise",
    h1_line_1: "Garage Flexfuel E85 & Reprogrammation Moteur",
    h1_line_2: "à Clermont-Ferrand",
    sections: [
      { title: "Conversion Flexfuel E85 — Roulez moins cher, roulez mieux", paragraph: "Nous équipons votre véhicule pour rouler à l'éthanol E85 dès {prix_flexfuel}..." },
      { title: "Reprogrammation Moteur Stage 1 & 2", paragraph: "Une reprogrammation Stage 1 vous apporte jusqu'à 25 % de puissance supplémentaire..." },
      { title: "Spécialiste Mécanique Véhicules Allemands", paragraph: "BMW, Mercedes, Audi, Volkswagen, Porsche..." },
      { title: "Pourquoi choisir Auvergne Tech Racing ?", paragraph: "Une équipe passionnée, des tarifs transparents..." },
    ],
  };
  // Admin-editable H1 from content.seo overrides the seo_editorial fields (single source of truth).
  const pageSeo = content?.seo || {};
  const h1Prefix = pageSeo.h1_prefix || seo.h1_line_1;
  const h1Highlight = pageSeo.h1_highlight || seo.h1_line_2;
  const ratingText = String(reviews.rating).replace(".", ",");
  const count = reviews.user_ratings_total;
  const countText = count && count >= 100 ? `plus de ${Math.floor(count / 10) * 10}` : `plus de ${count || 88}`;
  const testIds = ["seo-flexfuel", "seo-reprog", "seo-allemand", "seo-choose"];

  // Interpolate {rating} and {count} tokens inside the "Pourquoi ATR" paragraph (last section)
  const interpolate = (p, i) => {
    if (i !== 3) return resolveOffer(p, offer);
    return p.replace("{rating}", ratingText).replace("{count}", countText);
  };

  return (
    <section
      id="expertise"
      className="relative py-20 md:py-28 bg-[#0A0A0A] border-t border-white/[0.06]"
      data-testid="seo-editorial-section"
      aria-labelledby="seo-page-title"
    >
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF3B30] mb-4">
            {seo.eyebrow}
          </p>
          <h1 id="seo-page-title" className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-white leading-tight">
            {h1Prefix}
            <br />
            <span className="text-white/50">{h1Highlight}</span>
          </h1>
        </div>

        <div className="space-y-12">
          {/* Static intro line for the last section so admins can keep the copy tidy */}
          {(seo.sections || []).map((s, i) => (
            <article key={i} data-testid={testIds[i] || `seo-section-${i}`}>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 tracking-tight">{s.title}</h2>
              <p className="text-white/70 leading-relaxed text-base md:text-lg whitespace-pre-line">
                {i === 3 ? (
                  <>
                    <strong className="text-yellow-400">{ratingText}/5 sur Google</strong> avec {countText}{" "}
                    <strong className="text-white">avis clients</strong>.{" "}
                    {interpolate(s.paragraph, i)}
                  </>
                ) : (
                  s.paragraph
                )}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

// ============== BOOKING SECTION ==============
